import { useLingui } from "@lingui/react/macro";
import { useMemo } from "react";

import { localizedName } from "../lib/localizedName";
import { RANK_SUBRANKS } from "../lib/RANK_SUBRANKS";
import { useAssets } from "./useAssets";

export type RankView = {
  badge: number;
  // «Аколит 5»; тира нет в справочнике — «Ранг 35».
  name: string;
  iconUrl: string | null;
};

// Ранг игрока по `rank_badge` (десятки — тир, единицы — подуровень 1–6) из справочника
// на языке интерфейса.
export const useRankLookup = (): ((badge: number) => RankView) => {
  const { i18n, t } = useLingui();
  const { data } = useAssets();
  const ranks = useMemo(
    () => new Map((data?.ranks ?? []).map((rank) => [rank.tier, rank])),
    [data],
  );
  return (badge: number) => {
    const tier = Math.floor(badge / 10);
    const subrank = badge % 10;
    const rank = ranks.get(tier);
    if (rank === undefined) {
      return { badge, name: t`Rank ${badge}`, iconUrl: null };
    }
    const tierName = localizedName(rank.name, i18n.locale);
    const hasSubrank = subrank >= 1 && subrank <= RANK_SUBRANKS;
    return {
      badge,
      name: hasSubrank ? `${tierName} ${String(subrank)}` : tierName,
      iconUrl: (hasSubrank ? rank.subrank_icon_urls[subrank - 1] : undefined) ?? rank.icon_url,
    };
  };
};
